// removed by extract-text-webpack-plugin
module.exports = {"easy-need-offer-container":"easy-need-offer-container","easy-need-offer-right-content":"easy-need-offer-right-content","easy-need-offer-wrap":"easy-need-offer-wrap","easy-need-offer-title":"easy-need-offer-title","view-more-link":"view-more-link","easy-need-offer":"easy-need-offer"};


//////////////////
// WEBPACK FOOTER
// ./components/home/sub-view/_EasyNeedOfferContainer.scss
// module id = ./components/home/sub-view/_EasyNeedOfferContainer.scss
// module chunks = 0